// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3JR6_","box":"WorkspacesBox_box__1G9bX","node":"WorkspacesBox_node__1InFQ"};